const { updateClientParams } = require("clients/api")

const updateClientCodeUseCase = codClient => {
    return updateClientParams({ codClient: parseInt(codClient) })
}

export default updateClientCodeUseCase